import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServerStatusService {
  private readonly connectionLostSubject = new BehaviorSubject<boolean>(false);

  readonly connectionLost$ = this.connectionLostSubject.asObservable();

  setConnectionLost(isLost: boolean): void {
    this.connectionLostSubject.next(isLost);
  }
}
